import React from 'react';
import { Flex } from 'core/components';
import SudoTag from './SudoTag';

export const SudoTagPosition = {
  Right: 'right',
  Left: 'left'
};

/**
 * SudoTaggedText displays text annotated with a SUDO tag. This is intended to indicate actions or views that are available only to sudo users.
 * The following props are available to use:
 * - tagPosition [optional]: indicates which side of your text the tag will be displayed. Options are 'right' | 'left'. Highly encourage using the SudoTagPosition const to specify this prop's value. Defaults to 'right'
 * - tagProps [optional]: provide a set of Tag props as an object that will be applied to the sudo tag.
 * - All other props are spread onto the container component (Flex)
 *
 * Usage example:
 * ```
 *   <SudoTaggedText tagPosition={SudoTagPosition.Left} tagProps={{ small: true }} mb={2}>
 *     This is a sudo-only action
 *   </SudoTaggedText>
 * ```
 */
const SudoTaggedText = ({ children, tagPosition = SudoTagPosition.Right, tagProps, ...props }) => (
  <Flex
    alignItems="center"
    justifyContent={tagPosition === SudoTagPosition.Left ? 'flex-start' : 'space-between'}
    gap="6px"
    {...props}
  >
    {tagPosition === SudoTagPosition.Right && children} <SudoTag {...tagProps} />
    {tagPosition === SudoTagPosition.Left && ' '}
    {tagPosition === SudoTagPosition.Left && children}
  </Flex>
);

export default SudoTaggedText;
